import {
    Paper,
    alpha,
    useTheme
} from '@mui/material';

const TabContainer = ({ children }) => {
    const theme = useTheme();
    return (
        <Paper
            sx={{
                borderRadius: 1,
                bgcolor: theme.palette.background.paper,
                boxShadow: 'none',
                border: '1px solid',
                borderColor: alpha(theme.palette.common.white, 0.1),
                overflow: 'hidden'
            }}
        >
            {children}
        </Paper>
    )
}

export default TabContainer;